import React from 'react';
import { AvatarDiv, RightDiv } from '../styles';
import Avatar from '../../../../../component/avatar';
import { AVATAR_BORDER } from '../../../../../global/constants';
import { ActiveUser } from '../../../../../interfaces/ProjectInterface';

interface DocActiveUsersProps {
  users: ActiveUser[];
}

const DocActiveUsers: React.FC<DocActiveUsersProps> = ({ users }) => {
  return (
    <AvatarDiv>
      {users.map((user, index) => (
        <RightDiv key={user.id || `${user.name}-${index}`}>
          <li>
            <Avatar
              imgSrc={user?.profile ? user?.profile : ''}
              name={user.name}
              size={20}
              borderVariant={AVATAR_BORDER.THIN}
            />
          </li>
        </RightDiv>
      ))}
    </AvatarDiv>
  );
};

export default DocActiveUsers;
